import { isValidElement, useEffect, useRef } from 'react';

const attachedEvent = new Event('flotiq.attached');
const detachedEvent = new Event('flotiq.detached');

const FromHtmlElement = ({
  htmlElement,
  order,
}: {
  htmlElement: HTMLElement;
  order?: number;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!htmlElement || !ref.current) return;
    ref.current.innerHTML = '';
    ref.current.appendChild(htmlElement);
    htmlElement.dispatchEvent(attachedEvent);
    return () => {
      htmlElement.dispatchEvent(detachedEvent);
    };
  }, [htmlElement]);

  return <div ref={ref} style={{ order: order }} />;
};

const ElementFromPlugin = ({
  results,
  order,
}: {
  results: any[];
  order?: number;
}) =>
  results.map((result, idx) => {
    return isValidElement(result) || typeof result !== 'object' ? (
      result
    ) : (
      <FromHtmlElement key={idx} htmlElement={result} order={order} />
    );
  });

export default ElementFromPlugin;
